<template>
  <!--中标结果公示-->
  <div class="evaluate">
    <van-tabs v-model="active" sticky @click="tabClick">
      <van-tab v-for="(item, index) in evaluateTitleList" :key="index" :name="item.name" :title="item.title">
        <div class="evaluate-div" v-if="item.name === '1'">
          <div v-if="list.length === 0 " class="noContent">
            <img src="../../assets/images/blank_icon_project.png">
            <div class="blank-tip">暂无内容</div>
          </div>
          <div v-else class="basic evaluate-content" v-for="(item, index) in list" :key="index">
            <van-tag color="#009CFF" round size="large" type="primary" v-if="item.isWin == 1">中标</van-tag>
            <van-tag color="#ccc" round size="large" type="primary" v-else>未中标</van-tag>
            <div class="evaluate-title">{{ item.name }}</div>
            <div class="timeBox" v-if="isMyRelease == 1">
              <div class="time">
                <!--简易-->
                <span class="timeTitle">投标金额</span>
                <span>{{ item.bidPrice | currency }}元</span>
              </div>
            </div>
          </div>
          <div class="bottom-btn" v-if="isMyRelease == 1">
            <van-button v-if="isNotice==1" class="van-button-1" color="#37A1FFFF" round @click="entertip" block>查看公告
            </van-button>
            <van-button v-if="isNotice==0" class="van-button-1" color="#37A1FFFF" round @click="announcement" block>
              发布公告
            </van-button>
            <van-button class="van-button-2" color="#096CEFFF" round @click="beginBuild(item.id)" block>开始施工
            </van-button>
          </div>

          <div class="bottom-btn" v-else>
            <van-button v-if="isNotice==1" color="#096CEFFF" round @click="entertip" block>查看公告</van-button>
          </div>

        </div>
        <div v-else>
          <!--项目详情-->
          <div class="project-info">
            <div class="announcementTitle" v-if="project.oldInfo">澄清后公告：</div>
            <projectInfo :project="project" :projectId="$route.query.id" :isMyRelease="isMyRelease" :oldInfo="0"/>
            <div class="announcementTitle" v-if="project.oldInfo">原公告：</div>
            <projectInfo :project="project.oldInfo" :projectId="$route.query.id" :isMyRelease="isMyRelease" :oldInfo="1"
                         v-if="project.oldInfo"/>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getNormalProjectInfo, beginBuild } from '@api/project'
import { getIsNotice } from '@api/invitationBids'
import { getTenderResult } from '@api/openTender'

import projectInfo from '@/components/projectInfo'

export default {
  name: 'evaluate',
  components: { projectInfo },
  data () {
    return {
      isMyRelease: 0,
      active: '1',
      evaluateTitleList: [
        { name: '1', title: '投标人' },
        { name: '2', title: '项目信息' }
      ],
      list: [],
      isNotice: '',
      project: {}
    }
  },
  created () {
    this.startTime = Date.now()

    this.id = this.$route.query.id
    // 是我发布的
    this.isMyRelease = this.$route.query.isMyRelease
    this.getIsNotice()
    // 获取中标队伍
    this.getTenderResult()
  },
  mounted () {
    // 初始化极光统计
    this.$jiguang.initCountEvent()
  },
  methods: {
    announcement () {
      const data = {
        title: '发布公告',
        url: `${process.env.VUE_APP_BASE_HOST}/announcePage?projectId=${this.id}`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },
    getTenderResult () {
      getTenderResult({
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 是否发布公告：0-未发布；1-已发布
    getIsNotice () {
      getIsNotice({
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          // 是否发布公告：0-未发布；1-已发布
          this.isNotice = res.data.data.isNotice
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    tabClick (name) {
      if (name === '1') {
        this.getTenderResult()
      } else if (name === '2') {
        this.getNormalProjectInfo()
      }
    },
    // 点击查看公告
    entertip () {
      let browTime = parseInt((Date.now() - this.startTime) / 1000)
      let brow = 'h5_project_info_browser,项目信息详情,项目,' + browTime
      // 初始化极光统计预览时长
      this.$jiguang.initBrowseEvent(brow)
      // 获取极光统计所需数据
      this.$bridge.callHandler('getDeviceInfo', 'h5_view_project_notice', response => {
        console.log('response:', response)
      })
      // this.enterRouter('entertipPage', {projectId: this.id})
      const data = {
        title: '查看公告',
        url: `${process.env.VUE_APP_BASE_HOST}/entertipPage?projectId=${this.id}`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },
    // 获取项目详情
    getNormalProjectInfo () {
      getNormalProjectInfo({ id: this.id }).then(res => {
        if (res.data.code === 200) {
          this.project = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 开始施工
    beginBuild (id) {
      let browTime = parseInt((Date.now() - this.startTime) / 1000)
      let brow = 'h5_project_info_browser,项目信息详情,项目,' + browTime
      // 初始化极光统计预览时长
      this.$jiguang.initBrowseEvent(brow)
      // 获取极光统计所需数据
      this.$bridge.callHandler('getDeviceInfo', 'h5_project_start_construction', response => {
        console.log('response:', response)
      })
      beginBuild({ projectId: this.id }).then(res => {
        if (res.data.code === 200) {
          this.$toast.success('操作成功')
          // 延迟1秒
          setTimeout(() => {
            this.$bridge.callHandler('backRefresh', response => {
              console.log('response:', response)
            })
          }, 1000)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.evaluate-div {
  margin-top: 10px;
  padding-bottom: 60px;
}

.evaluate-content {
  padding-top: 10px;
}

.project-info {
  padding-top: 15px;
  padding-bottom: 60px;
}

.evaluate-title {
  @include add_size($font_size_20);
  //display: -webkit-box;
  //-webkit-box-orient: vertical;
  //-webkit-line-clamp: 2;
  //overflow: hidden;
}

.van-tag {
  padding: 5px 15px;
  margin-bottom: 10px;
}

.timeBox {
  .time {
    @include add_size($font_size_18);
    padding-top: 8px;

    .timeTitle {
      color: #999999;
      padding-right: 5px;
    }
  }
}

</style>
